import PropTypes from "prop-types";
import Checkbox from "../../../components/Checkbox/Checkbox";
import { PRODUCTS } from "./ProductSelector";
import styles from "./Institution.module.scss";

const AUTH_TYPES = {
  IP: "ip",
  URL: "url",
  OPENATHENS: "openathens",
};

const AuthenticationFields = ({
  isExisting,
  authenticationType,
  selectedProducts,
  ipAddress,
  urlReferrals,
  openAthensId,
  onAuthenticationToggle,
  onInputChange,
  onUrlReferralChange,
}) => {
  return (
    <div className={styles.authSection}>
      <div className={styles.authHeader}>
        <label className={styles.label}>Authentication type</label>
        <a
          href="https://www.tg.org.au/whatisauthentication"
          className={styles.authLink}
          target="_blank"
          rel="noopener noreferrer"
        >
          What is authentication?
        </a>
      </div>
      <div className={styles.authOptionsContainer}>
        {/* IP Authentication */}
        <div className={styles.authOption}>
          <Checkbox
            checked={authenticationType.includes(AUTH_TYPES.IP)}
            onChange={() => onAuthenticationToggle(AUTH_TYPES.IP)}
            label="IP authentication"
          />
          {authenticationType.includes(AUTH_TYPES.IP) && (
            <input
              type="text"
              className={styles.authInput}
              placeholder={
                isExisting
                  ? "Enter an IP or range only if there are any changes.(e.g.142.250.72.0/24)"
                  : "Enter IP address or range (e.g., 142.250.72.0/24)"
              }
              value={ipAddress}
              onChange={(e) => onInputChange("ipAddress", e.target.value)}
            />
          )}
        </div>

        {/* URL Referral */}
        <div className={styles.authOption}>
          <Checkbox
            checked={authenticationType.includes(AUTH_TYPES.URL)}
            onChange={() => onAuthenticationToggle(AUTH_TYPES.URL)}
            label="Referral URL"
          />
          {authenticationType.includes(AUTH_TYPES.URL) && (
            <div className={styles.urlReferralContainer}>
              {selectedProducts.map((productId) => {
                const product = PRODUCTS.find((p) => p.id === productId);
                return (
                  <div key={productId} className={styles.productUrlField}>
                    <label className={styles.productUrlLabel}>
                      Referral URL – {product?.name || productId}
                    </label>
                    <input
                      type="text"
                      className={styles.authInput}
                      placeholder={
                        isExisting
                          ? "Enter a Referring URL only if there are any changes (e.g., https://yourorg.com)"
                          : "Enter referral URL (e.g., https://yourorg.com)"
                      }
                      value={urlReferrals[productId] || ""}
                      onChange={(e) => onUrlReferralChange(productId, e.target.value)}
                    />
                  </div>
                );
              })}
            </div>
          )}
        </div>

        {/* OpenAthens */}
        <div className={styles.authOption}>
          <Checkbox
            checked={authenticationType.includes(AUTH_TYPES.OPENATHENS)}
            onChange={() => onAuthenticationToggle(AUTH_TYPES.OPENATHENS)}
            label="Open Athens"
          />
          {authenticationType.includes(AUTH_TYPES.OPENATHENS) && (
            <input
              type="text"
              className={styles.authInput}
              placeholder="Enter OpenAthens organization ID"
              value={openAthensId}
              onChange={(e) => onInputChange("openAthensId", e.target.value)}
            />
          )}
        </div>
      </div>
    </div>
  );
};

AuthenticationFields.propTypes = {
  isExisting: PropTypes.bool.isRequired,
  authenticationType: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedProducts: PropTypes.arrayOf(PropTypes.string).isRequired,
  ipAddress: PropTypes.string.isRequired,
  urlReferrals: PropTypes.object.isRequired,
  openAthensId: PropTypes.string.isRequired,
  onAuthenticationToggle: PropTypes.func.isRequired,
  onInputChange: PropTypes.func.isRequired,
  onUrlReferralChange: PropTypes.func.isRequired,
};

export default AuthenticationFields;
